export function downloadBlob(response) {
  let a = document.createElement("a")
  let blob = new Blob([response.data])
  let blobUrl = window.URL.createObjectURL(blob, { type: response.data.type })
  document.body.appendChild(a)
  a.style = "display: none"
  a.href = blobUrl;
  a.download = getFilename(response.headers["content-disposition"])
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(blobUrl)
}

export function openBlobOnTab(response) {
  const blob = new Blob([response.data], { type: response.data.type });
  const blobUrl = window.URL.createObjectURL(blob, { type: response.data.type });
  window.open(blobUrl, '_blank');
  window.URL.revokeObjectURL(blobUrl);
}

// デコードするとスペースが"+"になる点に注意
function getFilename(contentDisposition) {
  let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2, contentDisposition.length);
  fileName = decodeURI(fileName).replace(/\+/g, " ");
  return fileName;
}
